import { humanReadableField } from '~/filters/humanReadableField';
import { battery, configured, lastSeen, mfgId, reachable, subtype } from '~/helpers/fields-description';
import { WirelessSwitch } from './WirelessSwitch.model';

export class NLT extends WirelessSwitch {
    get fieldSubtype() {
        return subtype(humanReadableField(this.subtype || 'N/A'));
    }
    get fieldLastSeen() {
        return lastSeen(this.last_seen, this.reachable ? '' : 'error--text');
    }
    get fieldConfigured() {
        return configured(this.configured);
    }
    get fieldMfgId() {
        return mfgId(typeof this.mfg_id !== 'undefined' ? this.mfg_id : undefined);
    }
    get fieldReachable() {
        return reachable(this.reachable);
    }
    get fieldBattery() {
        return battery(this.getBatteryIcon(this.battery_vp), this.battery_vp);
    }
}
